import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Rating from "@mui/material/Rating";
import {CardActions} from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import {useTheme} from "@mui/material/styles";
import {useTranslation} from "react-i18next";

export default function ModelCards(props) {
    const theme = useTheme();
    // init internationalization
    const {t} = useTranslation();

    // styles
    const cardStyles = {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        color: "black",
        justifyContent: "space-between",
        border: 0,
        cursor: "pointer",
        borderRadius: "20px",
        backgroundColor: theme.palette.background.default,
        transition: "background-color 200ms, box-shadow 200ms",
        "& .MuiTypography-body1": {
            color: "black",
        },
        "&.disabled": {
            pointerEvents: "none",
            background: "#0000000a" // almost transparent
        },
        "&:hover, &.selected": {
            backgroundColor: theme.palette.primary.light,
            border: 0,
            boxShadow: "2px 2px 5px #00000057",
            transition: "background-color 200ms, box-shadow 200ms",
            "& .MuiTypography-h5": {
                color: theme.palette.primary.dark,
                transition: "color 300ms",
            },
        },
        "& .MuiCardActions-root": {
            margin: `${theme.spacing(2)} ${theme.spacing(3)}`
        }
    };

    const cardStylesOptional = {
        ...cardStyles,
        backgroundColor: theme.palette.secondary.light,
        "&:hover, &.selected": {
            backgroundColor: theme.palette.secondary.main,
            border: 0,
            boxShadow: "2px 2px 5px #00000057",
            transition: "background-color 200ms, box-shadow 200ms",
            "& .MuiTypography-h5": {
                color: theme.palette.background.paper,
                transition: "color 300ms",
            },
            "& .MuiButton-textPrimary": {
                color: theme.palette.background.paper,
                transition: "color 300ms",
            }
        },
    }


    return (
        <>
            {Object.keys(props.modelHyperParams).map((modelName) => (
                    // Render Model Cards
                    <Grid item lg={3} md={4} xs={12}
                          sx={{display: "flex", alignItems: "stretch"}}
                          key={t(`trainer.Title${modelName.replace(/\s/g, '')}`)}>
                        <Card
                            onClick={props.handleModelChange(modelName)}
                            sx={props.isOptional? cardStylesOptional : cardStyles}
                            className={`modelCards ${
                                modelName === props.selectedModel && "selected"
                            } ${props.disabled ? "disabled" : ""}`}
                        >
                            {!props.isOptional ? (
                                    <CardContent sx={{minHeight: "150px"}}>
                                        <Typography variant="h5" gutterBottom>
                                            {t(`trainer.Title${modelName.replace(/\s/g, '')}`)}
                                        </Typography>

                                        <>
                                            <Typography
                                                sx={{mb: 1.5}}
                                                color="text.secondary"
                                            > <br/>
                                                {t(`trainer.Description${modelName.replace(/\s/g, '')}`)}
                                            </Typography>
                                            <Typography component="legend">
                                                <br/>
                                                {t("trainer.ExpectedQuality")}
                                            </Typography>
                                            <Rating
                                                name="read-only"
                                                size="small"
                                                value={t(`trainer.Quality${modelName.replace(/\s/g, '')}`)}
                                                readOnly
                                            />
                                            <Typography component="legend">
                                                {t("trainer.ExpectedSpeed")}
                                            </Typography>
                                            <Rating
                                                name="read-only"
                                                size="small"
                                                value={t(`trainer.Speed${modelName.replace(/\s/g, '')}`)}
                                                readOnly
                                            />
                                        </>
                                    </CardContent>
                                )
                                : (
                                    <CardContent sx={{minHeight: "50px"}}>
                                        <Typography variant="h5" gutterBottom>
                                            {t(`trainer.Title${modelName.replace(/\s/g, '')}`)}
                                        </Typography>
                                    </CardContent>
                                )}

                            <CardActions
                                sx={{justifyContent: "space-between"}}
                            >
                                <Button
                                    size="small"
                                    onClick={props.handleModelChange(modelName)}
                                    disabled={modelName === props.selectedModel}
                                >
                                    {t("common.SelectButton")}
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                )
            )}
        </>
    );
}